import React, { FC } from 'react';
import Tooltip from 'react-tooltip';
import { FormattedMessage } from 'react-intl';
import { SearchCommentariesModal } from '../commentaries-modal/SearchCommentariesModal';
import { doctrineAnalytics } from '../../../../utils/analyticsUtils';
import { createRandomKey } from '../../../../utils/jsxUtils';
import { useRestrictedModal } from '../../../../components/modal/useRestrictedModal';
import { useModal } from '../../../../components/modal/useModal';
import { getCommentariesLabel } from './getCommentariesLabel';
import { useUser } from '../../../../user/useUser';
import styles from './hit_commentaries_list_see_more.module.scss';
import { Commentary } from '../../../../commentary/commentary.types';
import { SmallTextButton } from '../../../../components/button/text/SmallTextButton';

type Props = {
  docId: string;
  searchType: string;
  numberOfComments: number;
  otherCommentAuthorsCount: number;
  nextCommentAuthors: string[];
  allCommentariesGetter: (
    docId: string,
    query: string,
  ) => Promise<{ data: Array<Commentary> }>;
};

export const HitCommentariesListSeeMore: FC<Props> = ({
  docId,
  allCommentariesGetter,
  searchType,
  numberOfComments,
  nextCommentAuthors = [],
  otherCommentAuthorsCount,
}) => {
  const { accessPremium } = useUser();
  const { openRestrictedModal } = useRestrictedModal();
  const { openModal } = useModal((modalProps) => (
    <SearchCommentariesModal
      docId={docId}
      allCommentariesGetter={allCommentariesGetter}
      searchType={searchType}
      {...modalProps}
    />
  ));
  const onClick = () => {
    if (accessPremium) {
      doctrineAnalytics('Search ModalCommentsOpened', {
        source: 'excerpt',
        doc_id: docId,
        reportOriginalQueryKey: true,
        search_type: searchType,
      });
      openModal();
    } else {
      openRestrictedModal({ source: 'excerpt_comments' });
    }
  };

  const id = `hit-comment-${createRandomKey()}`;
  const authorsLabel = getCommentariesLabel(
    nextCommentAuthors,
    otherCommentAuthorsCount,
  );

  return (
    <>
      <SmallTextButton
        onClick={onClick}
        data-for={id}
        data-tip
        data-offset="{'top': -10}"
      >
        <FormattedMessage
          id="HitCommentariesListSeeMore/button"
          values={{ count: numberOfComments }}
        />
      </SmallTextButton>

      <Tooltip effect="solid" place="right" id={id}>
        <div className={styles.tooltip}>{authorsLabel}</div>
      </Tooltip>
    </>
  );
};
